export default {enter_email:'Введите, пожалуйста, email.'};